var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller } from "react-hook-form";
import { AfyCardPreset } from "@affinitysystemsgroup/assurehub-ui";
import { IconCalendarStats, IconRefresh, IconSparkles } from "@tabler/icons-react";
import { Panel, PanelHeaderRow, PanelTitle, PanelSubtitle, PresetGrid } from "../style/billingTypePresets.style";
import { BILLING_PRESET_PANEL_SUBTITLE, BILLING_PRESET_PANEL_TITLE, } from "../../../constants/billing.constants";
var PRESET_ICONS = {
    GENERAL: _jsx(IconCalendarStats, { size: 19 }),
    NEW: _jsx(IconSparkles, { size: 19 }),
    REBILLING: _jsx(IconRefresh, { size: 19 }),
};
export var BillingTypePresetsView = function (props) {
    if (props.options.length === 0)
        return null;
    return (_jsxs(Panel, { children: [_jsxs(PanelHeaderRow, { children: [_jsx(PanelTitle, { children: BILLING_PRESET_PANEL_TITLE }), _jsx(PanelSubtitle, { children: BILLING_PRESET_PANEL_SUBTITLE })] }), _jsx(Controller, { control: props.control, name: "billingType", render: function (_a) {
                    var field = _a.field;
                    return (_jsx(PresetGrid, __assign({ role: "radiogroup", "aria-label": BILLING_PRESET_PANEL_TITLE }, { children: props.options.map(function (option) { return (_jsx(AfyCardPreset, { icon: PRESET_ICONS[option.value], name: option.name, description: option.description, selected: field.value === option.value, onClick: function () { return field.onChange(option.value); } }, option.id)); }) })));
                } })] }));
};
